import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BACKEND_URL } from '../app.config';
import { LegacyReview } from '../api/data-model';

@Injectable({
  providedIn: 'root'
})
export class LegacyReviewService {

  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) {

  }
  // getLegacyReview(id: string): Observable<LegacyReview> {
  //   return this.http.get<LegacyReview>(this.baseUrl + '/api/app/legacy-review/' + id);
  // }
// getLegacyReview(id: string, entityType: number): Observable<LegacyReview> {
//   return this.http.post<LegacyReview>(`${this.baseUrl}/api/app/legacy-review/${id}`, { entityType });
// }
  getLegacyReview(id: string, entityType: number): Observable<LegacyReview> {
    return this.http.get<LegacyReview>(`${this.baseUrl}/api/app/legacy-review/${id}`, {
      params: {
        id: id,
        entityType: entityType,
      },
    });
  }
// getLegacyReview(id: string, entityType: number): Observable<LegacyReview> {
//   // 使用 HttpParams 设置查询参数
//   const params = new HttpParams()
//     .set('entityType', entityType.toString());

//   return this.http.get<LegacyReview>(
//     `${this.baseUrl}/api/app/legacy-review/${id}`,
//     { params }
//   );
// }
  updateLegacyReview(legacyReview: LegacyReview): Observable<LegacyReview> {
    return this.http.post<LegacyReview>(`${this.baseUrl}/api/app/legacy-review`, legacyReview);
  }

}
